import { useI18n } from '@ecom/i18n';
import { EmptyState } from '@ecom/ui-kit';
import { type ReactElement, useState } from 'react';

import { useInventoryOverviewQuery, type InventoryRow } from '../api';
import { InventoryTable } from '../components/InventoryTable';
import { StockAdjustDrawer } from '../components/StockAdjustDrawer';

import { TableSkeleton } from '@/components/ui/skeletons/TableSkeleton';

export function InventoryPage(): ReactElement {
  const { t } = useI18n();
  const overview = useInventoryOverviewQuery();
  const [adjusting, setAdjusting] = useState<InventoryRow | null>(null);

  return (
    <div className="mx-auto flex max-w-6xl flex-col gap-6">
      <div>
        <h1 className="font-display text-2xl font-bold text-ink">{t('merchant.nav.inventory')}</h1>
        <p className="text-sm text-inkFaint">{t('merchant.inventory.subtitle')}</p>
      </div>

      {overview.isPending ? (
        <TableSkeleton columns={4} />
      ) : overview.isError ? (
        <EmptyState title={t('merchant.inventory.loadError')} />
      ) : overview.rows.length === 0 ? (
        <EmptyState
          title={t('merchant.inventory.emptyTitle')}
          description={t('merchant.inventory.emptyDescription')}
        />
      ) : (
        <InventoryTable
          rows={overview.rows}
          onAdjust={(row) => {
            setAdjusting(row);
          }}
        />
      )}

      {adjusting !== null ? (
        <StockAdjustDrawer
          productId={adjusting.productId}
          variantId={adjusting.variantId}
          productName={adjusting.productName}
          sku={adjusting.sku}
          onClose={() => {
            setAdjusting(null);
          }}
        />
      ) : null}
    </div>
  );
}
